import React from 'react';
import { Button } from '@metarouter-private/mr-mui';
import useTestPipelineButtonProps from './useTestPipelineButtonProps';
import WithTooltip from 'app/components/WithTooltip';

export default function TestPipelineButton() {
  const buttonProps = useTestPipelineButtonProps();
  const { disabled, disabledTitle, ...restProps } = buttonProps;
  return (
    <WithTooltip show={disabled} title={disabledTitle}>
      <Button {...restProps} disabled={disabled}>
        Test
      </Button>
    </WithTooltip>
  );
}
